import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const HotelPricedRecommendationTypeIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", {
    width: "60",
    height: "62",
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, __jsx("g", {
    filter: "url(#filter0_dd_25836_116108)"
  }, __jsx("path", {
    d: "M8 15.9631C8 14.2417 9.25183 12.7758 10.9521 12.5063L47.9521 6.64161C50.0771 6.30479 52 7.94693 52 10.0985V41.9677C52 43.687 50.7513 45.1517 49.0536 45.4236L12.0536 51.3507C9.92687 51.6913 8 50.0486 8 47.8947V15.9631Z",
    fill: "#05BC50"
  }), __jsx("g", {
    "clip-path": "url(#clip0_25836_116108)"
  }, __jsx("path", {
    d: "M38.8168 40.9997H21.1813C20.1379 40.9997 19.2892 39.9915 19.2892 38.752V26.5189L30.0023 17L40.7088 26.5189V38.752C40.7088 39.9915 39.8602 40.9997 38.8168 40.9997ZM19.9383 26.9045V38.752C19.9383 39.5655 20.4965 40.2286 21.1813 40.2286H38.8168C39.5015 40.2286 40.0598 39.5655 40.0598 38.752V26.9045L30.0023 17.9638L19.9383 26.9045Z",
    fill: "white",
    stroke: "white",
    "stroke-width": "0.5"
  }), __jsx("path", {
    d: "M33.2377 41H26.7599C26.5814 41 26.4354 40.8265 26.4354 40.6145V28.2117C26.4354 27.9997 26.5814 27.8262 26.7599 27.8262H33.2377C33.4162 27.8262 33.5623 27.9997 33.5623 28.2117V40.6145C33.5623 40.8265 33.4162 41 33.2377 41ZM27.0845 40.2289H32.9132V28.5972H27.0845V40.2289Z",
    fill: "white",
    stroke: "white",
    "stroke-width": "0.5"
  }), __jsx("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M31.8323 33.834C32.1016 33.834 32.3191 34.0923 32.3191 34.4123C32.3191 34.7323 32.1016 34.9906 31.8323 34.9906C31.5629 34.9906 31.3454 34.7323 31.3454 34.4123C31.3454 34.0923 31.5645 33.834 31.8323 33.834Z",
    fill: "white",
    stroke: "white",
    "stroke-width": "0.5"
  }), __jsx("path", {
    d: "M41.3499 28.8616C41.2152 28.8616 41.0789 28.8115 40.962 28.7074L30.0023 18.9668L19.0377 28.7074C18.7505 28.9618 18.3432 28.8924 18.129 28.5512C17.9148 28.21 17.9732 27.7262 18.2605 27.4717L30.0023 17.0391L41.7393 27.4717C42.0265 27.7262 42.0849 28.21 41.8707 28.5512C41.7426 28.7555 41.5462 28.8616 41.3499 28.8616Z",
    fill: "white",
    stroke: "white",
    "stroke-width": "0.5"
  }))), __jsx("defs", null, __jsx("filter", {
    id: "filter0_dd_25836_116108",
    x: "0",
    y: "0.597656",
    width: "60.4307",
    height: "60.834",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, __jsx("feFlood", {
    "flood-opacity": "0",
    result: "BackgroundImageFix"
  }), __jsx("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), __jsx("feOffset", {
    dy: "2"
  }), __jsx("feGaussianBlur", {
    stdDeviation: "4"
  }), __jsx("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), __jsx("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.15 0 0 0 0 0.302069 0 0 0 0 0.5 0 0 0 0.15 0"
  }), __jsx("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25836_116108"
  }), __jsx("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), __jsx("feOffset", {
    dy: "3.39"
  }), __jsx("feGaussianBlur", {
    stdDeviation: "2.26"
  }), __jsx("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), __jsx("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0313726 0 0 0 0 0.113725 0 0 0 0 0.294118 0 0 0 0.3 0"
  }), __jsx("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_25836_116108",
    result: "effect2_dropShadow_25836_116108"
  }), __jsx("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_25836_116108",
    result: "shape"
  })), __jsx("clipPath", {
    id: "clip0_25836_116108"
  }, __jsx("rect", {
    width: "26",
    height: "26",
    fill: "white",
    transform: "translate(17 16)"
  }))));
};
export default HotelPricedRecommendationTypeIcon;